import client from "../client";

export interface GetTransactionCommissionByMebmerIDResponse {
  HashKey?: string;
  Amount?: number;
  NameEN?: string;
  CreatedAt?: Date;
  UpdatedAt?: Date;
  DisplayCreatedAt?: string;
  DisplayUpdatedAt?: string;
  Uncalculated?: boolean;
  Reject?: boolean;
}

export default function API(): Promise<
  GetTransactionCommissionByMebmerIDResponse[]
> {
  return client
    .get(`commission/get_transaction_commission_by_member_id`)
    .then((response) => response.data);
}
